import React, { useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import { CardView, rem } from 'design-system';
import Modal from 'utils/packages/Modal';
import { IconFatPlus } from 'design-system/icons';
import { SettingsItem } from 'design-system/SettingsItem';
import IconSpace from 'design-system/icons/IconSpace';
import createStyleSheets from 'utils/createStyleSheets';
import useStyles from 'hooks/useStyles';
import { isWeb } from '../../../constants';
const JoinSpaceModalContent = ({ onJoinSpace, onCreateSpace, }) => {
    const webStyles = useStyles(webStyleSet);
    const onPressCreateSpace = useCallback(() => {
        Modal.hide(onCreateSpace);
    }, [onCreateSpace]);
    const onPressJoinSpace = useCallback(() => {
        Modal.hide(onJoinSpace);
    }, [onJoinSpace]);
    if (isWeb) {
        return (<View style={styles.modalContent}>
        <CardView noMargin webPadding style={webStyles.modalContent}>
          <SettingsItem style={webStyles.settingsItem} icon={<IconFatPlus />} title="Create a space" onPress={onPressCreateSpace}/>
          <SettingsItem style={webStyles.settingsItem} icon={<IconSpace gradientKey="ultimate"/>} title="Join a space" onPress={onPressJoinSpace}/>
        </CardView>
      </View>);
    }
    return (<View style={styles.modalContent}>
      <SettingsItem icon={<IconFatPlus />} title="Create a space" onPress={onPressCreateSpace}/>
      <SettingsItem icon={<IconSpace gradientKey="ultimate"/>} title="Join a space" onPress={onPressJoinSpace}/>
    </View>);
};
export default JoinSpaceModalContent;
const styles = StyleSheet.create({
    modalContent: {
        paddingTop: rem(12),
    },
});
const webStyleSet = createStyleSheets((colors) => ({
    modalContent: {
        marginHorizontal: rem(16),
        backgroundColor: colors.background.light,
    },
    settingsItem: {
        margin: rem(16),
    },
}));
